import React from 'react'

const Watch = () => {
  return (
    <div>
      Watch
    </div>
  )
}

export default Watch
